import "@/App.css";

function App() {
  return (
    <div className="App" data-testid="app-container">
      <iframe
        data-testid="mirror-iframe"
        src="/site/index.html"
        title="Perfect World - Denise Proctor"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          border: 'none',
          margin: 0,
          padding: 0,
          overflow: 'hidden',
          zIndex: 1,
        }}
      />
    </div>
  );
}

export default App;
